import { arrayEach } from '@isyscore/utils/array';
import { objectAssign } from '@isyscore/utils/object';
import { isString, isFunction } from '@isyscore/utils/type';

const defaults = {
    maxLength: 99,
    delimiter: ':'
};
const _options = Symbol();
const _eventsStore = Symbol();
const _eventsPipeList = Symbol();
class Events {
    constructor(options) {
        this[_options] = objectAssign({}, defaults, options);
        this[_eventsStore] = {};
        this[_eventsPipeList] = [];
    }
    /**
     * 添加事件监听
     * @param {EventsChannel} channel
     * @param {EventsListener} listener
     * @returns {this}
     */
    on(channel, listener) {
        const store = this._getStoreByChannel(channel);
        const { maxLength } = this[_options];
        if (store.length === maxLength)
            throw new Error(`同一个通道的事件监听数量不能超过 ${maxLength} 个`);
        store.push(listener);
        return this;
    }
    /**
     * 一次性事件监听
     * @param {EventsChannel} channel
     * @param {EventsListener} listener
     * @returns {this}
     */
    once(channel, listener) {
        const _listener = (...payloads) => {
            this.off(channel, _listener);
            listener.call(this, ...payloads);
        };
        return this.on(channel, _listener);
    }
    /**
     * 解除事件监听
     * @param {EventsChannel} channel
     * @param {EventsListener} listener
     * @returns {this}
     */
    off(channel, listener) {
        if (isString(channel) && isFunction(listener))
            this._offOne(channel, listener);
        else if (isString(channel))
            this._offBatch(channel);
        else
            this._offAll();
        return this;
    }
    /**
     * 触发事件
     * @param {EventsChannel} channel
     * @param {any} payloads
     * @returns {this}
     */
    emit(channel, ...payloads) {
        const store = this._getStoreByChannel(channel);
        const { delimiter } = this[_options];
        arrayEach(store.slice(), (listener) => {
            if (listener.call(this, ...payloads) === false)
                return false;
            arrayEach(this[_eventsPipeList].slice(), (piper) => {
                const { target, namespace = '' } = piper;
                const ns = [channel];
                if (namespace)
                    ns.unshift(namespace);
                const targetChannel = ns.join(delimiter);
                target.emit(targetChannel, ...payloads);
            });
        });
        return this;
    }
    /**
     * 事件传递
     * @param {this} target
     * @param {string} namespace
     * @returns {this}
     */
    pipe(target, namespace) {
        this[_eventsPipeList].push({
            target,
            namespace
        });
        return this;
    }
    destroy() {
        this.off();
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this._eventsStore = null;
    }
    _getStoreByChannel(channel) {
        const eventsStore = this[_eventsStore];
        const { [channel]: store = [] } = eventsStore;
        eventsStore[channel] = store;
        return store;
    }
    _offOne(channel, listener) {
        const store = this._getStoreByChannel(channel);
        const index = store.findIndex((item) => item === listener);
        if (index === -1)
            return;
        store.splice(index, 1);
    }
    _offBatch(channel) {
        delete this[_eventsStore][channel];
    }
    _offAll() {
        this[_eventsStore] = {};
    }
}

export default Events;
export { defaults };
